import { useAlert as useAlertDialog } from "@/components/common/AlertDialog";
import { useToast } from "@/components/common/Toast";
/**
 * Combined hook for alerts and toasts
 * Provides easy-to-use methods for showing notifications
 */
export const useAlert = () => {
    const { showAlert, showConfirm } = useAlertDialog();
    const toast = useToast();
    /**
     * Show a simple alert dialog (replaces window.alert)
     */
    const alert = async (title, message) => {
        await showAlert({
            title: title || "Alert",
            message: message || "",
            type: "info",
            confirmText: "OK",
        });
    };
    /**
     * Show a confirmation dialog (replaces window.confirm)
     * Returns true if confirmed, false if cancelled
     */
    const confirm = async (message, title, options) => {
        return await showConfirm(message, title, options);
    };
    return {
        alert,
        confirm,
        toast,
        showAlert,
    };
};
